import { API, API_POST } from "../../Config";

export const handleUpdateOrder = (order_status, id, otp) => {
  const f = new FormData();
  f.append("order_status", order_status);
  f.append("id", id);
  if (order_status === 2) {
    f.append("otp", otp);
  }

  return API_POST(API.EditOrderStatus, f);
};
